import { Route, Routes } from 'react-router-dom';
import './App.css';
import AddBook from './components/AddBook';
import Navbar from './components/Navbar';
import Home from './pages/Home';

function App() {
  return (
    <>
    
   <div>
 <Navbar/>
 <main className="py-6 2xl:px-6 container">

<Routes>
  <Route path='/' element={<Home/>} />
  <Route path='/add-book' element={<AddBook  key={'add-book'}/>} />
  <Route path='/edit-book/:bookId' element={<AddBook key={'edit-book'}/>} />
</Routes>


</main>
</div>

    </>
  );
}

export default App;
